import { render, staticRenderFns } from "./TagsDisplayer.vue?vue&type=template&id=2faee19a&scoped=true&"
import script from "./TagsDisplayer.vue?vue&type=script&lang=js&"
export * from "./TagsDisplayer.vue?vue&type=script&lang=js&"
import style0 from "./TagsDisplayer.vue?vue&type=style&index=0&id=2faee19a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faee19a",
  null
  
)

export default component.exports